import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Header, Segment, Table } from 'semantic-ui-react'
import FeedItem from './FeedItem'
import InfoPopup from '~/components/InfoPopup'
import { HERD_GROUP_ERROR_CLASS } from '../../../constants'

interface HerdGroupFeedsProps {
  herdIndex: number
}

const HerdGroupFeeds: React.FC<HerdGroupFeedsProps> = ({ herdIndex }) => {
  const { t } = useTranslation()
  const { control, getValues } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `herdGroups[${herdIndex}].feeds`,
    keyName: 'key'
  })

  return (
    <>
      <Header attached='top' block>
        {t('Feeds')}
      </Header>
      <Segment attached>
        <Table celled>
          <colgroup>
            <col style={{ width: '30%' }} />
            <col style={{ width: '30%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '10%' }} />
          </colgroup>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t('Feed component')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Region')}</Table.HeaderCell>
              <Table.HeaderCell>
                <div style={{ display: 'flex', gap: 5 }}>
                  <div>{t('DM / animal / day')}</div>
                  <InfoPopup
                    content={t('Enter dry matter (DM) intake per animal per day averaged throughout the whole year.')}
                    styleIcon={{ fontSize: '1.2em', color: 'white' }}
                />
                </div>
              </Table.HeaderCell>
              <Table.HeaderCell>{t('FW / animal / day')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Actions')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {fields.map((field, feedIndex) => (
              <FeedItem
                key={field.key}
                id={field.key}
                index={feedIndex}
                herdIndex={herdIndex}
                removeFeed={remove}
              />
            ))}
          </Table.Body>
        </Table>
        <div style={{ display: 'flex', justifyContent: 'end', marginTop: '1em' }}>
          <Button
            type='button'
            size='small'
            icon='plus'
            style={{ color: 'white' }}
            content={t('Add Feed')}
            onClick={() => {
              const id = getValues(`herdGroups[${herdIndex}].id`)
              const element = document.getElementById(id)
              if (element && element.classList?.contains(HERD_GROUP_ERROR_CLASS)) {
                element.classList.remove(HERD_GROUP_ERROR_CLASS)
              }
              append({
                id: null,
                cftFeedRegionId: null,
                dryMatterValue: null,
                freshWeightValue: null
              })
            }}
          />
        </div>
      </Segment>
    </>
  )
}

export default HerdGroupFeeds
